import { useState } from "react";

export const CopyStatsButton = ({ getText }: { getText: () => string | Promise<string> }) => {
	const [status, setStatus] = useState<"idle" | "copying" | "copied" | "error">("idle");
	return <span className="d-inline-flex align-items-center gap-2 mb-2">
		<button type="button" className="btn btn-light-bordered btn-xs" disabled={status === "copying"} onClick={async () => {
			setStatus("copying");
			try {
				await navigator.clipboard.writeText(await getText());
				setStatus("copied");
			} catch {
				setStatus("error");
			}
		}}>{status === "copying" ? "Copying…" : "Copy stats"}</button>
		<span role="status" className={status === "error" ? "text-danger" : "text-body-secondary"}>{status === "copied" ? "Copied!" : status === "error" ? "Could not copy stats. Please try again." : ""}</span>
	</span>;
};
